import { isEmplid, isIdmuid, isNameN } from "../../../util/functions";

export const createUser = `mutation CreateUser($createUserInput: CreateUserInput!) {
    createUser(input: $createUserInput) {
        message
        error
    }
}`;

export function getCreateUserInput(id, password) {
    let createUserInputVariables = {
        createUserInput: {
            password,
        },
    };
    
    if (isEmplid(id)) {
        createUserInputVariables.createUserInput.emplid = id;
    } else if (isIdmuid(id)) {
        createUserInputVariables.createUserInput.idmuid = id;
    } else if (isNameN(id)) {
        createUserInputVariables.createUserInput.nameN = id;
    } else {
        throw "Invalid id format provided"; // eslint-disable-line
    }
    
    // console.info(createUserInputVariables);
    
    return createUserInputVariables;
}